export class vndEvent {
  eventType: string;
  constructor(eventType: string) {
    this.eventType = eventType;
  }
}

export class drawingToolSelected extends vndEvent {
  toolId: string;

  constructor(toolId: string) {
    super("drawingToolSelected");
    this.toolId = toolId;
  }
}

export class toggleSetting extends vndEvent {
  settingName: string;
  newValue: boolean;

  constructor(settingName: string, newValue: boolean) {
    super("toggleSetting");
    this.settingName = settingName;
    this.newValue = newValue;
  }
}

export class miscEvent extends vndEvent {
  description: string;

  constructor(description: string) {
    super("miscEvent");
    this.description = description;
  }
}
